<div class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Pay In</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClose()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <form [formGroup]="payInForm" class="p-3">
                    <div class="form-group mb-4" [ngClass]="isCustomerDisabled? 'hide-element':'' ">
                        <ng-select formControlName="customer" [compareWith]="compareById" [items]="usersList"
                            bindLabel="FirstName" bindValue="ID" [searchable]="true" placeholder="Select Customer"
                            [clearable]="false" class="w-100">
                            <ng-template ng-option-tmp let-user="item">
                                <div class="d-flex align-items-center">
                                    <i *ngIf="user.UserType === 'user'" class="pi pi-user mr-2"></i>
                                    <i *ngIf="user.UserType === 'shop'" class="material-icons mr-2"
                                        style="font-size:17px;">storefront</i>
                                    {{ user.FirstName }}
                                </div>
                            </ng-template>
                        </ng-select>
                        <div *ngIf="customer?.touched && customer?.invalid" class="text-danger small mt-1">
                            <div *ngIf="customer?.errors?.['required']">Customer is required.</div>
                        </div>
                    </div>

                    <div class="form-group mb-4">
                        <label for="amount">Pay In Amount :</label>
                        <input type="number" id="amount" class="form-control" placeholder="Enter Amount (₹)"
                            formControlName="amount" />
                    </div>
                    <div *ngIf="amount?.touched && amount?.invalid" class="text-danger small mt-1">
                        <div *ngIf="amount?.errors?.['required']">Amount is required.</div>
                        <div *ngIf="amount?.errors?.['min']">Amount must be at least 1.</div>
                    </div>
                    <div class="form-group mb-4 ">
                        <label for="amount">Payment :</label>
                        <button class="btn btn-primary form-control"
                            style="background-color:#fff; color:#808080; border-color:#808080;"
                            (click)="openPaymentModal()">Select</button>
                    </div>
                </form>
            </div>

            <!-- <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" data-dismiss="modal"
                    (click)="onClose()">Close</button>
                <button type="button" [disabled]="!isSubmitEnabled" class="btn btn-primary" (click)="onSubmit()"
                    style="background-color:#673AB7; color:#fff; border-color:#673AB7;">Submit</button>
            </div> -->
        </div>
    </div>
</div>

<app-payment-methods *ngIf="showPaymentModesModal" [totalReceivable]="payInForm.get('amount').value"
    [calledFrom]="calledFrom" (close)="handlePaymentModalClose()"
    (paymentSaved)="handlePaymentSaved($event)"></app-payment-methods>